import { createSagaAction } from '../../../shared/sagas'
import { createReducer } from '../../../shared/reducers'

// Constants
export const constants = {
  FETCH_TESTING: createSagaAction('FETCH_TESTING'),
  CREATE_TESTING: createSagaAction('CREATE_TESTING'),
  UPDATE_TESTING: createSagaAction('UPDATE_TESTING'),
  DELETE_TESTING: createSagaAction('DELETE_TESTING'),

  CHANGE_TESTING_REVISION: createSagaAction('CHANGE_TESTING_REVISION'),

  UPLOAD_TESTING_ATTACHMENT: createSagaAction('UPLOAD_TESTING_ATTACHMENT'),
  FETCH_TESTING_ATTACHMENTS: createSagaAction('FETCH_TESTING_ATTACHMENTS'),
  UPDATE_TESTING_ATTACHMENT_DESCRIPTION: createSagaAction('UPDATE_TESTING_ATTACHMENT_DESCRIPTION'),
  DELETE_TESTING_ATTACHMENT: createSagaAction('DELETE_TESTING_ATTACHMENT')
}

// Action Creators
export const actions = {
  fetchTesting: jobId => ({
    type: constants.FETCH_TESTING.ACTION,
    jobId
  }),

  createTesting: (jobId, formData) => ({
    type: constants.CREATE_TESTING.ACTION,
    jobId,
    formData
  }),

  updateTesting: (testingId, jobId, formData) => ({
    type: constants.UPDATE_TESTING.ACTION,
    testingId,
    jobId,
    formData
  }),

  deleteTesting: (testingId, jobId) => ({
    type: constants.DELETE_TESTING.ACTION,
    testingId,
    jobId
  }),

  // Attachment actions
  uploadTestingAttachment: (formData, testingId) => ({
    type: constants.UPLOAD_TESTING_ATTACHMENT.ACTION,
    formData,
    testingId
  }),

  fetchTestingAttachments: testingId => ({
    type: constants.FETCH_TESTING_ATTACHMENTS.ACTION,
    testingId
  }),

  updateTestingAttachmentDescription: (attachmentId, testingId, description) => ({
    type: constants.UPDATE_TESTING_ATTACHMENT_DESCRIPTION.ACTION,
    attachmentId,
    testingId,
    description
  }),

  deleteTestingAttachment: ({ attachmentId, testingId }) => ({
    type: constants.DELETE_TESTING_ATTACHMENT.ACTION,
    attachmentId,
    testingId
  })
}

// Reducer
const initialState = {
  loading: false
}

export default createReducer(initialState, (state, action) => {
  switch (action.type) {
    case constants.FETCH_TESTING.ACTION:
      return { ...state, loading: true }
    case constants.FETCH_TESTING.SUCCESS:
      return {
        ...state,
        loading: false,
        items: action.payload
      }
    case constants.FETCH_TESTING.FAILED:
      return { ...state, loading: false }

    case constants.CREATE_TESTING.ACTION:
      return { ...state, loading: true }
    case constants.CREATE_TESTING.SUCCESS:
      return { ...state, loading: false }
    case constants.CREATE_TESTING.FAILED:
      return { ...state, loading: false }

    case constants.UPDATE_TESTING.ACTION:
      return { ...state, loading: true }
    case constants.UPDATE_TESTING.SUCCESS:
      return { ...state, loading: false }
    case constants.UPDATE_TESTING.FAILED:
      return { ...state, loading: false }

    case constants.DELETE_TESTING.ACTION:
      return { ...state, loading: true }
    case constants.DELETE_TESTING.SUCCESS:
      return { ...state, loading: false }
    case constants.DELETE_TESTING.FAILED:
      return { ...state, loading: false }

    case constants.UPLOAD_TESTING_ATTACHMENT.ACTION:
      return { ...state, error: null, uploadingAttachment: true }
    case constants.UPLOAD_TESTING_ATTACHMENT.SUCCESS:
      return {
        ...state,
        uploadingAttachment: false
      }

    case constants.FETCH_TESTING_ATTACHMENTS.ACTION:
      return { ...state, error: null, loadingAttachments: true }
    case constants.FETCH_TESTING_ATTACHMENTS.SUCCESS:
      return {
        ...state,
        attachments: action.payload,
        loadingAttachments: false
      }

    case constants.UPDATE_TESTING_ATTACHMENT_DESCRIPTION.SUCCESS:
      return { ...state }

    case constants.DELETE_TESTING_ATTACHMENT.ACTION:
      return { ...state, error: null, deletingAttachment: true }
    case constants.DELETE_TESTING_ATTACHMENT.SUCCESS:
      return { ...state, deletingAttachment: false }

    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/jobFunctions/testingActions.js